<template>
  <v-data-table flat
    :headers="headers"
    :items="resources"
    class="elevation-2"
    :loading="isLoading"
    :total-items="resourcesCount"
    :rows-per-page-items="limitOptions"
    :pagination.sync="pagination"
  >
    <template slot="items" slot-scope="props">
      <td class="text-xs-left">{{ props.item.id }}</td>
      <td class="text-xs-left">{{ props.item.protocol }}</td>
      <td class="text-xs-left">{{ props.item.codigo_receita }}</td>
      <td class="text-xs-left">{{ props.item.nome_empresa }}</td>
      <td class="text-xs-left">{{ $n((props.item.valor_principal), 'currency') }}</td>
      <td>{{ $d(formatDueDate(props.item.data_vencimento), 'short') }}</td>
      <td class="text-xs-left">
        <v-chip :class="setClass(props.item.status)" small text-color="white">
          {{ $t(`status.${props.item.status}`) }}
        </v-chip>
      </td>
      <td>{{ $d(new Date(props.item.created_at), 'short') }}</td>
      <td class="text-xs-left">
        <router-link
          :to="{ name: 'darf-payments-show', params: { id: props.item.id }}"
        >
          Consultar
        </router-link>
      </td>
    </template>
  </v-data-table>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { changed } from '@/helpers/layout';

export default {
  mounted() {
    this.$store.dispatch('bills/loadDarfsPayment', this.filters);
  },
  computed: {
    ...mapGetters({
      resources: 'bills/darfsPaymentList',
      resourcesCount: 'bills/darfsPaymentResourcesCount',
      limitOptions: 'bills/darfsPaymentLimitOptions',
      limit: 'bills/darfsPaymentLimit',
      currentPage: 'bills/darfsPaymentCurrentPage',
      filters: 'bills/darfsPaymentFilter',
      isLoading: 'bills/darfsPaymentLoadingData',
      darfErrors: "bills/darfPaymentError"
    })
  },
  components: {
    NumericRow: () => import('./billsTable/NumericRow.vue'),
    DateRow: () => import('./billsTable/DateRow.vue'),
    LinkRow: () => import('./billsTable/LinkRow.vue'),
    TextRow: () => import('./billsTable/TextRow.vue'),
    ChipRow: () => import('./billsTable/ChipRow.vue'),
    BrandRow: () => import('./billsTable/BrandRow.vue'),
  },
  watch: {
    pagination: function pagination(newPagination, oldPagination) {
      if( changed(newPagination.rowsPerPage, oldPagination.rowsPerPage) ) {
        this.setLimit(newPagination.rowsPerPage);
        this.$store.dispatch('bills/loadDarfsPayment', this.filters);
      }
      if( changed(newPagination.page, oldPagination.page) ) {
        this.setCurrentPage(newPagination.page);
        this.$store.dispatch('bills/loadDarfsPayment', this.filters);
      }
    },
  },
  methods: {
    ...mapActions({
      setCurrentPage: 'bills/setDarfsPaymentCurrentPage',
      setLimit: 'bills/setDarfsPaymentLimit',
    }),
    setChipColor(color) {
      return this.$t(`colors.${color}`);
    },
    setClass(status) {
      return `invoice ${status}`;
    },
    formatDueDate(dueDate){
      var dueDate = new Date(dueDate)
      return dueDate.setDate(dueDate.getDate() + 1)
    }
  },
  data() {
    return {
      items: [],
      count: 0,
      pagination: {},
      headers: [
        { text: 'Id Pagamento', value: 'id', sortable: true },
        { text: 'Protocolo', value: 'protocol', sortable: true },
        { text: 'Código Receita', value: 'codigo_receita', sortable: true },
        { text: 'Empresa', value: 'nome_empresa', sortable: true },
        { text: 'Valor Principal', value: 'valor_principal', sortable: true },
        { text: 'Data Vencimento', value: 'data_vencimento', sortable: true },
        { text: 'Status', value: 'status', sortable: true },
        { text: 'Criado em', value: 'created_at', sortable: true },
        { text: 'Consultar', value: 'actions', sortable: false },
      ],
    };
  },
};
</script>

<style>
/* DARF Payment Status Colors */
.v-chip.invoice.pending { background-color: #1976D2 !important; } /* primary - blue */
.v-chip.invoice.check_payment { background-color: #29B6F6 !important; } /* info - light blue */
.v-chip.invoice.waiting_payment_day { background-color: #FFC107 !important; } /* warning - yellow */
.v-chip.invoice.paid { background-color: #4CAF50 !important; } /* success - green */
.v-chip.invoice.rejected { background-color: #F44336 !important; } /* error - red */
.v-chip.invoice.unknow { background-color: #9E9E9E !important; } /* secondary - gray */
</style>